export enum BaseEnvironment {
  dev = 'dev',
  demo = 'demo',
  prod = 'prod',
  stage = 'stage',
}
